module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_8017.6d3d01fb.png";